export const AUTH_AUTOFILL_WEB = {
  EMAIL: "email",
  USERNAME: "username",
  CURRENT_PASSWORD: "current-password",
  NEW_PASSWORD: "new-password",
  ONE_TIME_CODE: "one-time-code"
};

export const AUTH_AUTOFILL_NATIVE = {
  EMAIL_ADDRESS: "emailAddress",
  PASSWORD: "password",
  NEW_PASSWORD: "newPassword",
  ONE_TIME_CODE: "oneTimeCode"
};

export const AUTH_INPUT_MODE = {
  EMAIL: "email",
  NUMERIC: "numeric"
};

export const AUTH_KEYBOARD_TYPE = {
  EMAIL_ADDRESS: "email-address",
  NUMERIC: "numeric"
};

export const authEmailInputProps = {
  autoCorrect: false,
  autoComplete: AUTH_AUTOFILL_WEB.EMAIL,
  textContentType: AUTH_AUTOFILL_NATIVE.EMAIL_ADDRESS,
  inputType: "email",
  inputMode: AUTH_INPUT_MODE.EMAIL,
  keyboardType: AUTH_KEYBOARD_TYPE.EMAIL_ADDRESS
};

export const authUsernameOrEmailInputProps = {
  autoCorrect: false,
  autoComplete: AUTH_AUTOFILL_WEB.USERNAME,
  textContentType: AUTH_AUTOFILL_NATIVE.EMAIL_ADDRESS
};

export const authCurrentPasswordInputProps = {
  autoComplete: AUTH_AUTOFILL_WEB.CURRENT_PASSWORD,
  textContentType: AUTH_AUTOFILL_NATIVE.PASSWORD
};

export const authNewPasswordInputProps = {
  autoComplete: AUTH_AUTOFILL_WEB.NEW_PASSWORD,
  textContentType: AUTH_AUTOFILL_NATIVE.NEW_PASSWORD
};
